import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import KEYS from '../../common/keyCodes';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import contextMenuPositionUtil from '../../util/contextMenuPosition';
import contextMenuButton from '../contextMenuButton.svg.js';
import { getRectByBoundingRect, getRectByReactElement } from '../../util/rect';
import { dataHooks } from './constants';
import DropDownBase from '../dropDownBase';

var getDefaultButton = function getDefaultButton() {
  return /*#__PURE__*/React.createElement('div', {
    key: 'contextBtn',
    className: 'context-menu-button',
    'data-hook': dataHooks.contextMenuButton,
    onMouseDown: function onMouseDown(event) {
      return event.stopPropagation();
    }
  }, /*#__PURE__*/React.createElement(contextMenuButton));
};

var ACTION_ENTER_FOLDER = 'ENTER_FOLDER';

var ContextMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(ContextMenu, _React$Component);

  var _super = _createSuper(ContextMenu);

  function ContextMenu(props) {
    var _this;

    _classCallCheck(this, ContextMenu);

    _this = _super.call(this, props);
    _this.state = {
      isOpen: false,
      arrowPosition: contextMenuPositionUtil.CONSTS.CHUPCHIK.POSITION.LEFT_TOP,
      optionsStyle: {},
      candidateKey: 0,
      candidatePath: null
    };
    _this.menuItems = [];

    _this.isOpen = function () {
      return _.isUndefined(_this.props.isOpen) ? _this.state.isOpen : _this.props.isOpen;
    };

    var setCandidate = function setCandidate(candidatePath
    /*, action*/
    ) {
      var candidateKey = _.get(_this.menuItems, candidatePath);

      if (Array.isArray(candidateKey)) {
        candidateKey = candidateKey[0];
      }

      _this.setState({
        candidatePath: candidatePath,
        candidateKey: candidateKey
      });
    };

    _this.toggleOptions = function (isOpen) {
      return _this.setState({
        isOpen: _.isUndefined(isOpen) ? !_this.isOpen() : isOpen,
        candidateKey: 0,
        candidatePath: null
      }, function () {
        if (_.isFunction(_this.props.onToggle)) {
          _this.props.onToggle(_this.state.isOpen);
        }
      });
    };

    _this.getCustomCloseKeys = function () {
      return _this.props.closeOnEnterOrSpace && !_this.hasFolders ? null : [KEYS.ESC];
    };

    var normalizePath = function normalizePath(nextPath, currentPath) {
      // Leave current if new path does not exist
      nextPath = _.get(_this.menuItems, nextPath) ? nextPath : currentPath; // If path leads to folder we need to add 0 to lead to folder item

      return Array.isArray(_.get(_this.menuItems, nextPath)) ? [].concat(_toConsumableArray(nextPath), [0]) : nextPath;
    };

    _this.getNewCandidatePath = function (direction) {
      var currentItemPath = _this.state.candidatePath;

      if (!currentItemPath) {
        return normalizePath([1], currentItemPath);
      }

      var isFolder = _.last(currentItemPath) === 0;
      var isFirst = _.last(currentItemPath) === 1;
      var currentItemOrFolder = isFolder ? currentItemPath.slice(0, currentItemPath.length - 1) : currentItemPath; // Go inside folder

      if (direction === 'IN') {
        if (!isFolder) {
          return currentItemPath;
        }

        var newPath = _toConsumableArray(currentItemPath);

        newPath[newPath.length - 1] = 1;
        return normalizePath(newPath, currentItemPath);
      }

      if (direction === 'OUT') {
        var _newPath = _toConsumableArray(currentItemPath);

        _newPath[_newPath.length - 1] = 0;
        return normalizePath(_newPath, currentItemPath);
      }

      if (direction === 'DOWN') {
        var _newPath2 = _toConsumableArray(currentItemOrFolder);

        _newPath2[_newPath2.length - 1]++;
        return normalizePath(_newPath2, currentItemPath);
      }

      if (direction === 'UP') {
        if (isFirst) {
          return currentItemPath;
        }

        var _newPath3 = _toConsumableArray(currentItemOrFolder);

        _newPath3[_newPath3.length - 1]--;
        return normalizePath(_newPath3, currentItemPath);
      }
    };

    _this.onKeyDown = function (e, isOpen) {
      if (isOpen) {
        if ([KEYS.UP, KEYS.DOWN, KEYS.LEFT, KEYS.RIGHT].includes(e.keyCode)) {
          var _KEYS$UP$KEYS$DOWN$KE;

          var direction = (_KEYS$UP$KEYS$DOWN$KE = {}, _defineProperty(_KEYS$UP$KEYS$DOWN$KE, KEYS.UP, 'UP'), _defineProperty(_KEYS$UP$KEYS$DOWN$KE, KEYS.DOWN, 'DOWN'), _defineProperty(_KEYS$UP$KEYS$DOWN$KE, KEYS.LEFT, 'OUT'), _defineProperty(_KEYS$UP$KEYS$DOWN$KE, KEYS.RIGHT, 'IN'), _KEYS$UP$KEYS$DOWN$KE)[e.keyCode];

          var candidatePath = _this.getNewCandidatePath(direction);

          setCandidate(candidatePath);
        } else if (e.keyCode === KEYS.ENTER || e.keyCode === KEYS.SPACE) {
          var action = _this.actionsMap[_this.state.candidateKey];

          if (action === ACTION_ENTER_FOLDER) {
            var _candidatePath = _this.getNewCandidatePath('IN');

            setCandidate(_candidatePath);
            e.stopPropagation();
            e.preventDefault();
          } else {
            if (_this.props.closeOnEnterOrSpace && action) {
              _this.toggleOptions(false);
            }

            action(e);
          }
        }
      }
    };

    _this.getButton = function () {
      return _this.props.customButton ? _this.props.customButton : getDefaultButton();
    };

    _this.onOptionsLayoutChange = function (optionsBoundingRect) {
      if (optionsBoundingRect) {
        var viewport = contextMenuPositionUtil.getViewportSize();
        var buttonRect = getRectByReactElement(_assertThisInitialized(_this));
        var optionsRect = getRectByBoundingRect(optionsBoundingRect);
        var params = {
          alignment: props.alignment,
          direction: props.direction
        };
        var optionsPosition = contextMenuPositionUtil.getOptionsPosition(viewport, buttonRect, optionsRect, params);
        var arrowPosition = contextMenuPositionUtil.getArrowPosition(buttonRect, optionsPosition);
        _this.lastValidOptionsX = _.isNaN(optionsPosition.x) ? _this.lastValidOptionsX : optionsPosition.x;

        _this.setState({
          arrowPosition: arrowPosition,
          optionsStyle: {
            top: optionsPosition.y,
            left: _this.lastValidOptionsX,
            height: optionsPosition.height,
            width: optionsPosition.width
          }
        });
      }
    };

    var lastItemKey = 0;

    var getItemKey = function getItemKey() {
      return ++lastItemKey;
    };

    var getDisplayName = function getDisplayName(node) {
      return _.invoke(node, 'type.getDisplayName');
    };

    var isFolder = function isFolder(node) {
      return getDisplayName(node) === displayNames.CONTEXT_MENU_FOLDER;
    };

    var isContent = function isContent(node) {
      return getDisplayName(node) === displayNames.CONTEXT_MENU_CONTENT;
    };

    var isAction = function isAction(node) {
      return !isFolder(node) && !isContent(node) && node.props.onClick;
    };

    var cleanChildren = function cleanChildren(rawChildren) {
      var children = _.isFunction(rawChildren) ? rawChildren() : rawChildren;
      return _.isArray(children) ? _.compact(children) : children;
    };
    /**
     * Next lines parse all the children and create the menuItems structure to be able to navigate items by keyboard,
     * open folders, apply actions etc.
     * There are three types of components inside the ContextMenu:
     *  - ContextMenuContent - just a wrapper around the menu items list
     *  - ContextMenuAction - action item to be clicked
     *  - ContextMenuFolder - menu item, which opens dropdown with more items on hover. Doesn't have action on click
     * Any other components are ignored.
     *
     * Every item has a unique ID generated by the getItemKey(), which is used to identify currently selected/clicked
     * element and apply action or highlight currently active one.
     *
     * The menuItems variable contains full list of actions/folders. It's an array of numbers or arrays.
     * Action item is a number (ID), folder is an array. First item in array conteins folder's ID as an action,
     * all other items have the same structure as menuItems. menuItems itself starts with null which is an ID
     * of root folder - context menu itself.
     *
     * Example:
     *  - Item 1 (1)
     *  - Item 2 (2)
     *  - Folder 1 (3)
     *     - Item 3 (4)
     *     - Item 4 (5)
     *     - Folder 2 (6)
     *        - Item 5 (7)
     *  - Item 6 (8)
     * This menu have next menuItems structure:
     * [null, 1, 2, [3, 4, 5, [6, 7]], 8]
     *
     * Active element is a one to be highlighted (or even open if it's folder)
     * If active element leads to folder itself, folder is highlighted but closed. If active element leads to
     * something inside folder, it's open.
     *
     * Navigation placed in getNewCandidatePath function, active/open logic in wrapMenu.
     *
     * Have fun :-)
     */


    var wrapMenuItem = null;
    var wrapFolder = null;
    var wrapChildrenList = null;
    var wrapContent = null;

    wrapMenuItem = function wrapMenuItem(node, prevPath, listIndex, menuItems) {
      var itemKey = getItemKey();
      menuItems.push(itemKey);
      _this.actionsMap[itemKey] = _.get(node, 'props.onClick');
      var itemPath = prevPath.concat(listIndex + 1);
      var active = itemKey === _this.state.candidateKey;

      var onClick = function onClick(e) {
        if (_this.props.closeOnClick) {
          _this.toggleOptions(false);
        }

        node.props.onClick(e);
      };

      return /*#__PURE__*/React.cloneElement(node, {
        onClick: onClick,
        active: active,
        onMouseEnter: function onMouseEnter() {
          return setCandidate(itemPath);
        }
      });
    };

    var isItemInsideFolder = function isItemInsideFolder(folderPath, itemPath) {
      if (!itemPath) {
        return false;
      } // Folder's first item means folder's key. So, '0' indexed item in folder means folder itself


      var folderItemPath = [].concat(_toConsumableArray(folderPath), [0]);

      if (_.isEqual(folderItemPath, itemPath)) {
        return false;
      } // If item's path starts wih folder's path, it's inside folder


      return _.isEqual(itemPath.slice(0, folderPath.length), folderPath);
    };

    wrapFolder = function wrapFolder(node, prevPath, listIndex, menuItems) {
      _this.hasFolders = true;
      var itemKey = getItemKey();
      var folderActions = [itemKey];
      menuItems.push(folderActions);
      _this.actionsMap[itemKey] = ACTION_ENTER_FOLDER;
      var folderPath = prevPath.concat(listIndex + 1);
      var itemPath = folderPath.concat(0);
      var active = itemKey === _this.state.candidateKey;
      var hasActiveInside = isItemInsideFolder(folderPath, _this.state.candidatePath);
      var children = cleanChildren(node.props.children);
      var wrappedChildren = wrapChildrenList(children, folderPath, folderActions);
      return /*#__PURE__*/React.cloneElement(node, {
        active: active,
        hasActiveInside: hasActiveInside,
        onMouseEnter: function onMouseEnter() {
          return setCandidate(itemPath);
        },
        onOptionsMouseLeave: _this.onOptionsMouseLeave,
        menuAlignment: _this.props.alignment,
        menuDirection: _this.props.direction
      }, wrappedChildren);
    };

    wrapChildrenList = function wrapChildrenList(nodes, prevPath, menuItems) {
      // This is used to keep listIndex (which is used to apply actions) in sync with elements list itself
      var foreignElementsQnt = 0;
      return React.Children.map(nodes, function (node, i) {
        if (isContent(node)) {
          return wrapContent(node, prevPath, menuItems);
        }

        if (isFolder(node)) {
          return wrapFolder(node, prevPath, i - foreignElementsQnt, menuItems);
        }

        if (isAction(node)) {
          return wrapMenuItem(node, prevPath, i - foreignElementsQnt, menuItems);
        }

        foreignElementsQnt++;
        return node;
      });
    };

    wrapContent = function wrapContent(node, prevPath, menuItems) {
      var children = cleanChildren(node.props.children);
      var wrappedChildren = wrapChildrenList(children, prevPath, menuItems);
      return /*#__PURE__*/React.cloneElement(node, node.props, wrappedChildren);
    };

    var wrapMenu = function wrapMenu(children) {
      lastItemKey = 0;
      _this.menuItems = [null];
      _this.actionsMap = {};
      _this.hasFolders = false;
      children = cleanChildren(children);

      if (isContent(children)) {
        return wrapContent(children, [], _this.menuItems);
      }

      return wrapChildrenList(children, [], _this.menuItems);
    };

    _this.traceClicksIfNeeded = wrapMenu;

    _this.optionsContainerClassName = function () {
      return [_this.props.optionsContainerClassName, 'context-menu-options', "arrow-".concat(_this.state.arrowPosition)].join(' ');
    };

    _this.onOptionsMouseLeave = function () {
      return setCandidate(null);
    };

    return _this;
  }

  _createClass(ContextMenu, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.isOpen() && _.isFunction(this.props.onToggle)) {
        this.props.onToggle(false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var options = this.traceClicksIfNeeded(this.props.children);
      return /*#__PURE__*/React.createElement(DropDownBase, {
        automationId: this.props.automationId,
        dataHook: this.props.dataHook,
        className: this.props.getClassName('control-context-menu'),
        disabled: this.props.disabled,
        blockScroll: this.props.blockScroll,
        allowInnerScroll: true,
        displayArrow: false,
        selected: this.getButton(),
        optionsStyle: this.state.optionsStyle,
        optionsInnerStyle: this.state.optionsInnerStyle,
        onLayoutChange: this.onOptionsLayoutChange,
        onKeyDown: this.onKeyDown,
        onOptionsMouseLeave: this.onOptionsMouseLeave,
        optionsContainerClassName: this.optionsContainerClassName(),
        customCloseKeys: this.getCustomCloseKeys(),
        customToggle: this.toggleOptions,
        isOpen: this.isOpen(),
        keepOptionsWidth: true,
        blockClickOutside: this.props.blockClickOutside,
        options: options
      });
    }
  }]);

  return ContextMenu;
}(React.Component);

ContextMenu.displayName = 'ContextMenu';
ContextMenu.propTypes = {
  isOpen: PropTypes.bool,
  disabled: PropTypes.bool,
  customButton: PropTypes.element,
  optionsContainerClassName: PropTypes.string,
  closeOnClick: PropTypes.bool,
  closeOnEnterOrSpace: PropTypes.bool,
  blockClickOutside: PropTypes.bool,
  blockScroll: PropTypes.bool,
  alignment: PropTypes.string,
  direction: PropTypes.string,
  onToggle: PropTypes.func
};
ContextMenu.defaultProps = {
  disabled: false,
  optionsContainerClassName: '',
  closeOnEnterOrSpace: true,
  closeOnClick: true,
  blockScroll: true
};
export default compose(ContextMenu);